export default {
    "pos": {
        "delete": "删除",
        "all": "全部",
        "pwd": "密码",
        "tooie": "朵颐",
        "close": "关闭",
        "password": "密码",
        "cancel": "取消",
        "phone": "联系电话",
        "price": "价格",
        "edit": "修改",
        "orders": "订单",
        "name": "姓名",
        "usages": {
            "events": {
                "action": "操作内容",
                "time": "操作时间",
                "user": "操作人"
            }
        },
        "staff": {
            "management": {
                "roles": {
                    "courier": "送餐员"
                }
            }
        },
        "role": {
            "staff": "员工",
            "admin": "管理员"
        },
        "alert": {
            "screesize": "您的浏览器宽度不足够，你要跳转到移动点餐界面吗？",
            "browser": {
                "android": "朵颐目前只支持谷歌浏览器。您可以在这里下载谷歌浏览器：<a target='blank' href='http://www.google.com/chrome/mobile'>谷歌浏览器</a>"
            },
            "license": {
                "expiry": "您的账户将在{0}天后到期！"
            }
        },
        "restaurant": {
            "logo": {
                "must": {
                    "be": {
                        "square": "餐厅LOGO必须为正方形图片"
                    }
                }
            }
        },
        "checkTableStatus": {
            "tip": "请完成所有餐桌订单并清台"
        },
        "session": {
            "lost": "登录失败,请重新登录"
        },
        "offline": {
            "settings": {
                "error": "目前没有网络，无法使用设置功能"
            }
        },
        "action": {
            "success": {
                "save": "保存成功！"
            },
            "failure": {
                "delete": "删除失败，请稍后再试",
                "save": "保存失败,请稍候再试!"
            }
        },
        "weborder": {
            "link": "网上点单地址"
        },
        "todayBills": {
            "refund": {
                "cancel": "取消退单",
                "confirm": "确认退单"
            },
            "selectAll": "全选"
        },
        "number": {
            "of": {
                "bill": {
                    "items": "餐品数量"
                }
            }
        },
        "help": {
            "is": {
                "not": {
                    "valid": "提示：会员密码输入错误，请重新输入"
                }
            },
            "usage": {
                "tag": "标签",
                "tagging": "标签功能"
            },
            "no": {
                "discount": "还没有创建单品折扣哦",
                "tag": "还没有创建标签哦"
            }
        },
        "enter": {
            "number": {
                "too": {
                    "large": "您输入的金额过大！"
                }
            }
        },
        "serverError": "无法连接朵颐服务器, 请稍后再试",
        "reserve": {
            "popup": {
                "informWay": {
                    "phone": {
                        "input": "请填写电话号码!"
                    }
                },
                "reserve": {
                    "time": {
                        "morning": "上午",
                        "afternoon": "下午"
                    }
                }
            }
        },
        "time": "下单时间",
        "system": {
            "status": "系统状态异常"
        },
        "booking": {
            "offline": "离线模式下不能使用订位绑定功能",
            "search": "请输入订位序号",
            "failed": "很抱歉, 没有找到订位序号: __orderNo__",
            "confirm": "请确定您要绑定 __name__ (__phone__) __count__位在 __date__ 的预订吗?",
            "display": "__orderNo__: __name__ (__phone__) __count__位"
        },
        "network": {
            "problem": {
                "text": "网络遇到了一点问题，请刷新再试"
            },
            "slow": "网速有点缓慢，请稍后",
            "dead": "网络异常",
            "checking": "正在检查网络...",
            "done": "网络正常，请耐心等待",
            "failed": "网络异常，请检查网络然后点击“刷新”",
            "refresh": "刷新",
            "offline": "网络出现问题, 请尽快检查网络状况避免数据流失! "
        },
        "reload": "请勿在离线模式下刷新，否则会丢失当前数据！",
        "error": "系统暂时无法加载，请按OK再试！",
        "license": {
            "purchase": {
                "title": "许可购买",
                "mode": "付费模式：",
                "mouth": "按月支付",
                "plan": "购买套餐：",
                "base": "基本套餐(限供两台设备使用)",
                "custom": "自定义设备数量",
                "tip1": "提示:自定义设备数量每超出1-3台设备(含电脑、平板、手机),需额外支付100元",
                "pay": "付款方式：",
                "alipay": "支付宝",
                "weixin": "微信",
                "tooie": "联系客服",
                "time": "购买时长：",
                "shouldPay": "应付金额：",
                "qrcode": "二维码：",
                "paybtn": "确认支付",
                "successed": "支付成功!",
                "unit1": "月",
                "unit2": "元 (人民币)",
                "tip2": "提示:",
                "tip3": "基本套餐或自定义套餐均包含所有功能(POS基础、会员功能、数据分析、微信餐厅等)"
            }
        },
        "search": {
            "label": "查询",
            "membership": {
                "id": "请输入会员卡号或联系电话进行查询",
                "weixin":"微信会员"
            }
        },
        "notification": {
            "name": {
                "pay": "支付",
                "center": "消息中心",
                "theme": "主题",
                "mark": "标记为",
                "error": "错误",
                "read": "已读",
                "system": "系统",
                "unread": "未读",
                "delete": "删除",
                "noMessage": "没有消息记录!"
            }
        },
        "cashier": {
            "invalidAuthentication": "用户名密码不正确！",
            "weixinPayment": "微信支付",
            "adminConfirm": "管理员输入密码确认",
            "add": {
                "note": "添加备注",
                "booking": "绑定订位信息"
            },
            "addnote": {
                "placeholder": "请输入备注信息"
            },
            "choose": {
                "waiter": "选择服务员"
            },
            "no": {
                "table": "没有需要结账的餐桌"
            },
            "discountOrTip": "折扣或小费",
            "pay": "完成收银",
            "public": "公开",
            "printOrderSlip": "打印账单"
        },
        "numberpad": {
            "clear": {
                "hint": "长按可取消所有输入"
            }
        },
        "charge": {
            "success": "充值成功"
        },
        "confirm": "确认",
        "header": {
            "reload": "刷新系统",
            "handover": "交接班",
            "changeStyle": "换肤",
            "kitchenSystem": "厨房管理系统",
            "cashier": "结账",
            "help": "帮助中心",
            "queue": "排队叫号",
            "activity": "活动",
            "license": "许可购买",
            "confirm": "确认",
            "charge": "会员充值",
            "online": {
                "order": "网络订单"
            },
            "order": "点餐",
            "overview": "餐桌",
            "settings": "系统设置",
            "weixin": "微信餐厅",
            "stats": "营收",
            "booking": "预约管理"
        },
        "refund": {
            "adminOnly": "只有管理员可以退单",
            "offline": "离线模式下不能退单",
            "bill": {
                "amount": "退款金额"
            }
        },
        "note": {
            "title": "备注：",
            "offline": "离线模式下不能使用备注功能"
        },
        "payment": {
            "error": {
                "membership": "会员卡余额不足，请选择其他方式付款",
                "paid": "订单已支付,请查看订单详情",
                "label": "请付完全款"
            },
            "over": {
                "pay": "您已经付够账单金额。"
            },
            "method": {
                "notice": "中可更换选定3个常用默认支付方式",
                "selectTitle": "选择支付方式",
                "CASH": "现金",
                "CREDIT_CARD": "银行卡",
                "MEMBER_CARD": "会员卡",
                "WECHAT": "微信支付",
                "ALIPAY": "支付宝",
                "OTHER_PAY": "其他",
                "IGNORE": "抹零",
                "tip": "小费",
                "COUPON": "优惠券"
            }
        },
        "modal": {
            "header": {
                "select": {
                    "discount": "选择折扣"
                }
            }
        },
        "weixin": {
            "account": {
                "bind": "微信扫一扫关注公众号,即可发起提现功能!"
            }
        },
        "membership": {
            "offline": "离线模式下不能使用会员功能",
            "save": "保存",
            "create": "创建",
            "type": "卡别",
            "card": {
                "no": {
                    "title": "卡号"
                }
            },
            "modal": {
                "type": "会员类型"
            },
            "table": {
                "thead": {
                    "card": {
                        "id": "卡号",
                        "type": "会员类型"
                    }
                }
            },
            "charge": {
                "modal": {
                    "charge": {
                        "label": "充值",
                        "amount": "可用余额",
                        "available.amount": "有效余额",
                        "available.time": "生效时间",
                        "deadline": "过期时间",
                        "name": "会员名",
                        "placeholder": "请输入金额",
                        "title": "充值金额",
                        "date": "充值日期",
                        "person": "充值人",
                        "history": "充值记录",
                        "type": "充值方式"
                    }
                },
                "type": {
                    "CASH": "现金",
                    "CREDIT_CARD": "银行卡",
                    "SCORE": "积分",
                    "OTHER_PAY": "其他",
                    "WEIXIN": "微信支付",
                    "ALIPAY": "支付宝"
                }
            },
            "topup": {
                "error": {
                    "amount": "充值金额必须大于0"
                }
            },
            "not": {
                "enough": "余额不足",
                "found": "没有找到对应的会员信息"
            },
            "payment": {
                "score": "积分"
            },
            "weixin": {
                "print": "打印二维码"
            },
            "search": {
                "cardIdOrFullname": "卡号或手机号"
            },
            "balance":"余额"
        },
        "print": {
            "invoice": "打印单据",
            "status": {
                "pluginDisconnected": "请确定Chrome插件或云端打印应用已经打开",
                "printerDisconnected": "有打印机汇报错误信息, 请尽快检查打印机状态!",
                "tooltip": "有{0}个收据无法打印，请检查打印机然后重试！"
            }
        },
        "printer": {
            "open": "打印插件已开启",
            "close": "打印插件未开启",
            "action": {
                "delete": {
                    "confirm": "确定要删除该标签吗?",
                    "tag": "删除标签"
                }
            },
            "type": {
                "network": "网络打印机",
                "tagPrinter": "网络打印机"
            },
            "config": {
                "tag": {
                    "label": "打印标签"
                },
                "setting": {
                    "list": {
                        "defaultlabel": "请选择打印机"
                    },
                    "delete": {
                        "confirm": "你确认删除打印机配置?"
                    }
                }
            },
            "receipt": {
                "refundAmount": "退款金额",
                "postage": {
                    "amount": {
                        "label": "运费"
                    }
                },
                "time": {
                    "label": "时间"
                },
                "shipping": {
                    "phone": {
                        "label": "电话"
                    }
                },
                "membership": {
                    "currency": {
                        "label": "货币"
                    },
                    "recharge": {
                        "label": "支付方式"
                    }
                },
                "type": {
                    "selection": {
                        "label": "选择要打印的账单类型"
                    }
                },
                "bill": {
                    "sid": "账单号"
                },
                "refund": {
                    "amount": {
                        "title": "退款单"
                    }
                },
                "payment": {
                    "IGNORE": {
                        "label": "抹零"
                    },
                    "TIP": {
                        "label": "小费"
                    }
                },
                "discount": {
                    "amount": {
                        "label": "折扣"
                    }
                },
                "should": {
                    "pay": {
                        "amount": {
                            "label": "应付金额"
                        }
                    }
                },
                "order": {
                    "amount": {
                        "label": "账单金额"
                    },
                    "receipt": {
                        "label": "账单金额",
                        "title": "对账单"
                    }
                },
                "dispatch": {
                    "receipt": {
                        "title": "传菜单"
                    }
                },
                "tag": {
                    "receipt": {
                        "title": "标签单"
                    }
                },
                "diner": {
                    "total": {
                        "count": {
                            "label": "用餐人数"
                        }
                    }
                }
            },
            "queue": {
                "clear": "清除未打印请求",
                "clearsuccess": "所有未打印请求已经成功删除"
            },
            "status": "打印机状态",
            "offline": "请打开打印软件Tooie Printer",
            "unconfig": "尚未配置打印机"
        },
        "today": {
            "emptyBills": "今日还没有任何账单",
            "emptyWebBills": "今天没有外卖订单",
            "salesTotal": "今日营业额"
        },
        "label": {
            "print": "打印",
            "table": {
                "close": "清台",
                "switch": "转台",
                "label": "餐桌",
                "item": {
                    "refund": {
                        "reason": {
                            "select": "请选择退菜原因",
                            "input": "请输入退菜原因",
                            "placeholder": "在此填写原因"
                        }
                    }
                }
            }
        },
        "menu": {
            "item": {
                "delete": "(已删除)",
                "short": {
                    "code": "快捷码"
                }
            }
        },
        "order": {
            "previous": "上页",
            "next": "下页",
            "menu": {
                "allItem": {
                    "title": "所有餐品"
                }
            },
            "items": {
                "quantity": {
                    "limitAlert": "账单的餐品数量已达到上限!"
                }
            },
            "bill": {
                "submit": {
                    "confirm": "是否确定提交订单",
                    "must": {
                        "select": {
                            "table": "必须选择餐台才允许提交",
                            "billitem": "你还未选择任何餐品"
                        }
                    }
                },
                "title": "已点餐品",
                "total": {
                    "amount": "账单金额"
                }
            },
            "confirm": {
                "title": "提示",
                "yes": "OK"
            },
            "no": {
                "items": "未查询到任何餐品"
            },
            "submit": "下单",
            "continue": "去下单",
            "table": {
                "number": "桌号",
                "select": "选择餐桌",
                "change": "切换餐桌"
            }
        },
        "comp": {
            "select": {
                "bill": {
                    "modal": {
                        "title": "选择订单",
                        "current": "当前订单"
                    }
                },
                "table": {
                    "modal": {
                        "title": "选择餐桌",
                        "current": "当前餐桌"
                    }
                }
            }
        },
        "save": "保存",
        "file": {
            "size": {
                "over": {
                    "1m": "上传文件大小不能超过1M"
                }
            }
        },
        "screensize": {
            "caution": "注意"
        },
        "request": {
            "password": {
                "text": "请顾客输入密码确认"
            }
        },
        "setting": {
            "print": {
                "reset": "您确定重置所有打印机吗?",
                "selectPrinter": "--选择当前使用打印机--",
                "notSaved": "无法保存打印设置, 请稍后再试",
                "printerName": "打印机名:",
                "printerWidth": "打印机宽度:",
                "saved": "打印设置保存成功"
            },
            "user": {
                "deleted": "用户删除成功",
                "updatePwd": "修改密码后，您需要重新登录",
                "deleteOnlyUser": "不可删除唯一用户",
                "delete": {
                    "failed": "用户删除失败"
                },
                "edit": "编辑员工",
                "new": "新建员工",
                "bind": {
                    "weixin": {
                        "msg": {
                            "generate": {
                                "code": {
                                    "failed": "获取二维码失败，请检查网络"
                                }
                            }
                        }
                    }
                },
                "disbind": {
                    "weixin": {
                        "msg": {
                            "generate": {
                                "code": {
                                    "failed": "解除绑定失败！"
                                }
                            }
                        }
                    }
                }
            },
            "payment": {
                "name": {
                    "error": "支付方式名字错误"
                }
            },
            "menu": {
                "newitem": "添加餐品",
                "newcat": "添加餐品分类",
                "edititem": "编辑餐品",
                "editcat": "编辑分类",
                "nonEmptyCategory": "请先删除此类别内的餐品",
                "emptyCategory": "此分类还未添加餐品",
                "menuItem": {
                    "soldOut": "售完"
                },
                "item": {
                    "price": {
                        "large": "餐品价格超出限制"
                    }
                }
            },
            "sales": {
                "topItems": {
                    "others": "其它",
                    "noBill": "今日还没有任何下单"
                },
                "emailSuccess": "已发送营业数据至您的邮箱{0}",
                "emailError": "发送邮件失败，请联系客服",
                "invalidTimeRange": {
                    "label": "开始时间必须在结束时间之前",
                    "60days": "所选时间段必须小于60天"
                },
                "refund": {
                    "all": "确认退款本单所有菜品? 您可点选单一菜品退菜"
                },
                "search": {
                    "noResult": "无法找到对应单号"
                },
                "download": {
                    "explanation": "服务器正在统计中，{0}秒后即可再次点击。"
                }
            },
            "table": {
                "newtable": "新建餐桌",
                "edittable": "修改餐桌",
                "deleteMsg": "您确认要删除此餐桌？",
                "name": {
                    "error": "餐桌名字只容许最多20个字符"
                }
            },
            "needRefresh": "请点击刷新",
            "settingSaved": "设置已保存",
            "membership": {
                "pwd": {
                    "confirm": "两次密码输入不一致",
                    "length": "密码长度不能小于6位",
                    "reset": {
                        "success": "密码重置成功",
                        "confirm": "是否重置密码?"
                    }
                },
                "noHistory": "7天內没有任何记录",
                "charge": {
                    "confirm": "您确定充值{0}至该会员账户吗?"
                },
                "deduct": {
                    "confirm": "您确定从该会员账户扣除{0}吗?"
                },
                "delete": {
                    "confirm": "确定删除该会员吗?"
                },
                "disable": {
                    "confirm": "您确认{0}此会员卡吗"
                },
                "scheme": {
                    "name": {
                        "not": {
                            "unique": "会员名类别名称已被使用，请重新填写！"
                        }
                    }
                },
                "connect": {
                    "fail": "连接失败!"
                }
            }
        },
        "validation": {
            "equal": "输入必须为{number}个字",
            "notEmpty": "此输入框不可为空",
            "excludeHTML": "不能包含“<”，“>”等符号",
            "greaterThan": "请填写正确价格",
            "lessThan": "必须少于{number}个字",
            "notMoreThan": "不能超过一个字符",
            "requireSelection": "请选择一个选项"
        },
        "discount": {
            "default": "默认折扣",
            "delete": {
                "confirm": "确定要删除折扣{0}吗?"
            },
            "unavailable": "无可用折扣",
            "type": {
                "ALL": "全部折扣",
                "Percentage": "比例折扣",
                "Amount": "定额折扣",
                "label": "折扣类型"
            },
            "usage": {
                "duplicate": "餐品“{0}”已经在列表中了。"
            },
            "use": {
                "error": "不能使用该折扣"
            }
        },
        "settings": {
            "fee": {
                "range": "服务费设置范围(0~99)"
            },
            "confirm": {
                "delete": {
                    "tag": "删除标签"
                }
            },
            "confirmDelete": "确定要删除 {0}?",
            "r": {
                "choose": {
                    "options": "请点击选项以继续"
                },
                "fee": {
                    "label": "服务费"
                },
                "web": {
                    "urlCode": {
                        "error": {
                            "label": "名称已被注册，请选择其它网站名",
                            "format": "网站名需少于10个字并不能有空格或其它标点符号"
                        }
                    }
                },
                "sub": {
                    "desc1": "当您需要在当前餐品的基础上添加品种时可使用“选项”功能。",
                    "desc2": "如“奶茶(大杯)”“奶茶(中杯)”“奶茶(小杯)”"
                },
                "paymentNote": {
                    "addAlert": "请输入需要添加的备注",
                    "maxError": "您最多只能添加10条快捷备注"
                }
            },
            "memberCard": {
                "alert": {
                    "sendMessage": {
                        "noMember": "会员不存在"
                    }
                }
            },
            "invalid": {
                "brandedlicense": "您购买的功能已经过期，请联系您的销售代表進行续期！"
            },
            "navigator": {
                "canting": {
                    "title": "餐厅设置"
                }
            },
            "member": "会员设置",
            "discount": {
                "value": "折扣金额",
                "percentError": "百分比折扣必须设定在0和100之间",
                "percentInputHint": "例如，打九折请输入 10 ，表明账单减免10%",
                "nameError": "折扣名称过长",
                "valueError": "折扣金额必须为大于0的数字",
                "valueInputHint": " 例如，输入 10，表明账单减免10元",
                "title": "折扣设置",
                "singe": {
                    "order": "单品折扣"
                },
                "status": {
                    "disabled": "停用",
                    "enabled": "启用"
                }
            },
            "licenses": {
                "empty": "没有购买历史供显示"
            },
            "license": {
                "label": "许可管理",
                "purchase": {
                    "purchasing": {
                        "expiry": {
                            "date": {
                                "to": "到"
                            }
                        }
                    },
                    "history": {
                        "purchasing": {
                            "item": "订购项",
                            "date": "订购时间",
                            "period": "订购期限",
                            "amount": "金额"
                        }
                    },
                    "item": {
                        "required": "必须选择至少一个购买项!"
                    },
                    "confirm": {
                        "payment": {
                            "alipay": "支付宝",
                            "method": "支付方式"
                        }
                    }
                }
            },
            "membership": {
                "qrcode": "会员注册二维码",
                "generate": "重新生成",
                "password": {
                    "new": "新密码",
                    "confirm": "确认密码",
                    "old": "旧密码"
                },
                "createscheme": "创建会员卡",
                "editscheme": "修改会员卡",
                "updateMembership": "修改会员",
                "createMembership": {
                    "error": "您需要先创建会员类型才可以添加新的会员！",
                    "label": "创建会员"
                }
            },
            "membershipscheme": {
                "delete": {
                    "confirm": " 确定要删除会员卡{0}吗？"
                }
            },
            "memberCardScheme": {
                "alert": {
                    "deleteScheme": {
                        "confirm": "您确认要删除吗?"
                    }
                }
            },
            "tag": {
                "name": {
                    "empty": {
                        "error": "标签名称不能为空"
                    },
                    "length": {
                        "error": "请输入一个长度20以内的标签名称"
                    },
                    "conflict": {
                        "error": "标签名称不能重复"
                    }
                }
            },
            "not": {
                "hava": {
                    "membership": {
                        "license": "您当前使用的版本没有会员功能，使用该功能请升级您的版本。"
                    }
                }
            },
            "weixin": {
                "withdrawal": {
                    "placeholder": "请输入提现金额",
                    "error": {
                        "label": "提现失败,请联系客服",
                        "decimal": "提现金额必须为整数"
                    },
                    "success": "我们已收到您的提现请求, 转账完成后会以微信通知"
                }
            },
            "booking": {
                "title": {
                    "edit": {
                        "resource": "编辑预订项"
                    },
                    "add": {
                        "resource": "新建预订项"
                    }
                }
            },
            "menu": "菜单设置",
            "print": "打印设置",
            "restaurant": "餐馆设置",
            "sales": "营业记录",
            "table": "餐桌设置",
            "area": "区域设置",
            "user": "员工管理",
            "payment": "支付设置",
            "bookingResource": "预约设置",
            "menuItemSoldOut": "估清设置"
        },
        "status": {
            "Refunded": "退单",
            "mobile": {
                "order": "移动点单"
            },
            "table": {
                "closed": "空桌"
            },
            "all": "全部餐桌",
            "closed": "(空桌)",
            "paid": "已付款",
            "unpaid": "未付款",
            "clear": "一键清台",
            "empty": "空桌"
        },
        "generate": {
            "demo": {
                "data": "生成演示数据"
            }
        },
        "mobile": {
            "order": {
                "hint": "生成二维码手机扫描进入移动点单",
                "experience": {
                    "restaurant": {
                        "alert": "体验餐厅不提供此功能, 请注册您自己的餐厅后再使用此功能.",
                        "register": "立即注册"
                    }
                }
            },
            "create": "生成"
        },
        "analytics": {
            "data": "运营分析"
        },
        "table": {
            "close": {
                "confirm": "清桌之后，您可以在“今日账单”里面找到该账单。"
            },
            "switch": {
                "success": "成功转到桌子{0}"
            },
            "no": {
                "selectable": "无备选餐桌"
            },
            "bill": {
                "dinerCount": "用餐人数"
            },
            "label": "餐桌",
            "item": {
                "urge": {
                    "label": "催菜",
                    "success": "催菜成功"
                },
                "refunded": "已退菜",
                "refund": {
                    "warning": "请填写退菜原因",
                    "label": "退菜",
                    "error": {
                        "takeout": "不能转到外卖桌",
                        "nulltarget": "请选择目标桌",
                        "nullbill": "没有账单，不能转桌",
                        "targetoccupied": "目标桌还有未完成账单"
                    },
                    "reason": {
                        "soldout": "告罄",
                        "wrong": "误点",
                        "other": "其他"
                    }
                },
                "status": {
                    "label": "餐品状态",
                    "toconfirm": "未确认",
                    "confirmed": "已确认",
                    "completed": "已上菜"
                },
                "billList": "今日账单",
                "time": {
                    "order": "下单时间"
                }
            },
            "cancel": {
                "bill": "取消订单"
            },
            "self": {
                "delivery": "自取"
            },
            "deliver": {
                "bill": "交易结束",
                "courier": "选择配送员",
                "name": "姓名:",
                "address": "地址:",
                "sid": "订单号：",
                "note": "备注:",
                "contact": {
                    "information": "联系方式:"
                }
            },
            "modal": {
                "refund": {
                    "empty": "请填写退单原因"
                },
                "billItems": "订单餐品"
            },
            "info": {
                "ordered": "已点餐品",
                "incomplete": "未上餐品",
                "lastupdated": "更新时间",
                "price": "账单金额"
            },
            "credit": {
                "bill": "挂账",
                "cancel": {
                    "bill": "取消挂账"
                }
            }
        },
        "quick": {
            "order": {
                "placeholder": "输入缩写快速搜索"
            }
        },
        "activity": {
            "menu": "体验新功能",
            "day": "天",
            "feature": {
                "analytics": "运营分析",
                "weixin": "微信餐厅"
            },
            "license": "免费体验许可",
            "join": "领取许可"
        },
        "experience": {
            "restaurant": {
                "alert": "您正在使用体验餐厅! 请点击注册您自己的餐厅.",
                "alertshort": "点击注册您的餐厅."
            }
        },
        "back": {
            "to": {
                "settings": "返回设置首页"
            }
        },
        "bill": {
            "antiSettlement": "反结账",
            "completed": {
                "fail": "完成订单失败，请确认订单状态。"
            },
            "paid": {
                "amount": "现收"
            },
            "pay": {
                "success": "支付成功"
            },
            "confirm": {
                "unpaid": "当前还有未结账订单,是否创建新单",
                "confirmation": "确定接受这个订单？"
            },
            "refund": {
                "success": "退款成功",
                "fail": "退款失败",
                "label": "退单",
                "amount": "退款",
                "onlinePay": "线上支付退款"
            },
            "complete": {
                "confirmation": "确定要把这订单状态改为已送出？"
            },
            "sid": "账单号",
            "items": {
                "status": {
                    "canceled": "已退菜",
                    "completed": "已上菜",
                    "confirmed ": "已确认",
                    "cooking": "制作中",
                    "toconfirm": "未确认"
                }
            },
            "cancel": {
                "label": "",
                "with": {
                    "online": {
                        "payment": "确定要取消这个订单？线上已付款项会自动退回给用户。"
                    }
                }
            },
            "bills": "账单",
            "status": {
                "Cancel": "取消",
                "Completed": "完成",
                "Cooking": "制作中",
                "ThirdParty": "已线上支付",
                "PreOrder": "待确认",
                "Refunded": "退单",
                "Delivering": {
                    "staff": "配送员",
                    "done": "已送达"
                },
                "label": "账单状态",
                "Queue": "已确认",
                "Paid": "已付款"
            }
        },
        "webchat": {
            "zopim": {
                "title": "点一点这里就可以跟客服聊天!"
            }
        },
        "quickSetting": {
            "menu": {
                "additem": "添加餐品",
                "typecat": "输入分类名",
                "typeitem": "输入菜品名",
                "typeprice": "输入价格",
                "typeShortCode": "输入快捷码",
                "catexist": "分类已存在",
                "itemexist": "菜品已存在",
                "deletefail": "删除失败"
            },
            "table": {
                "next": "下一步"
            },
            "print": {
                "chooseReceipt": "请选择需要打印的单据类型",
                "paymentReceipt": "收款单",
                "itemSlip": "出品单",
                "returnSlip": "退菜单"
            }
        },
        "amount": {
            "change": "找零",
            "title": {
                "paid": {
                    "amount": "现收"
                },
                "bill": {
                    "amount": "账单金额"
                },
                "should": {
                    "pay": {
                        "amount": "应付"
                    }
                }
            },
            "explanation": "包含退单项目的金额",
            "original": "账单金额"
        }
    },
    "help": {
        "popup": {
            "enquirenow": "立即咨询 >",
            "helpcenter": {
                "label": "帮助中心",
                "desc": "24小时可查阅，包括朵颐使用说明以及常见问题",
                "time": "服务时间：24小时"
            },
            "phone": {
                "label": "电话服务热线",
                "desc": "更好更快的贴心服务热线",
                "number": "服务电话：027－8282 2869",
                "time": "服务时间：9:00－16:00"
            },
            "webchat": {
                "label": "在线服务",
                "desc": "在线为您解决问题，帮你节省各种电话费，您的服务首选",
                "time": "服务时间：9:00－16:00"
            },
            "title": {
                "newhand": "新手入门？多种渠道帮助您了解朵颐！",
                "label": "遇到问题了？多种渠道为您解决！"
            }
        }
    },
    "consult": {
        "popup": {
            "title": "您已获取朵颐团队30分钟免费线上技术咨询!",
            "technical": {
                "support": "您将从朵颐技术团队中获取以下技术支持:",
                "installationAndUse": "安装指导与使用答疑",
                "featuresAndBuy": "功能介绍与购买咨询",
                "aboutSystem": "帮助我更好了解系统去适应使用"
            },
            "noThanks": "暂时不使用，谢谢",
            "reserveConsultTime": "预约咨询时间",
            "chatOnline": "与线上客服安排时间"
        }
    },
    "reserve": {
        "popup": {
            "title": "请选择你想预约咨询的时间",
            "reserve": {
                "range": "您可以预约到最近5天",
                "choose": {
                    "informWay": "选择通知方式"
                },
                "time": {
                    "morning": "上午",
                    "afternoon": "下午"
                },
                "informWay": {
                    "email": "注册邮箱",
                    "phone": {
                        "input": "请填写电话号码!",
                        "label": "电话!"
                    }
                }
            },
            "noThanks": "不，下次吧",
            "sure": {
                "fail": "预约失败",
                "success": "确认预约"
            }
        }
    },
    "logout": "退出系统",
    "webpos": {
        "offline": "离线"
    },
    "restaurant": {
        "setting": "餐馆设置"
    },
    "guide": {
        "feature": {
            "registration": {
                "title": "注册账号",
                "desc": "恭喜您完成了下单体验! 快来体验其他功能或者是点击'马上注册'就可以享受7天免费试用喔! ",
                "action": "马上注册"
            },
            "analytics": {
                "title": "数据分析",
                "desc": "详细的数据，简明的图表分析助您时刻了解餐厅的营业情况"
            },
            "membership": {
                "title": "会员功能",
                "desc": "创建餐厅的个性e—会员卡，客户可以在会员卡上充值，并在结账的时候使用会员卡消费。"
            },
            "wechat": {
                "title": "微信点餐",
                "desc": "开通微信餐厅，顾客通过微信用自己的手机点菜下单。开通外卖功能顾客即可通过微信点外卖."
            },
            "mobilepos": {
                "title": "手机点菜宝",
                "desc": "服务员可以利用手机当作点菜宝般点餐, 快捷方便, 节省成本, 无需投入额外金钱购买特殊硬件."
            },
            "booking": {
                "title": "预约",
                "desc": "客户可从微信中预约用餐，餐厅可从朵颐系统中处理预约要求并透过微信自动通知和提醒客户预约状态"
            },
            "payments": {
                "title": "线上支付",
                "desc": "顾客结账时可直接扫描账单上的二维码进行线上支付(微信支付或支付宝）"
            }
        },
        "close": "关闭",
        "start": "开始体验",
        "qrcode": "用微信扫一扫二维码开始体验"
    },
    "experience": {
        "title": "朵颐体验餐厅",
        "consult": "客服",
        "feature": "其他功能",
        "register": "注册",
        "consult_long": "联系客服",
        "feature_long": "其他功能",
        "register_long": "注册帐号",
        "selectTable": "点击餐桌, 开始点餐",
        "selectItem": "点一点菜名去加菜",
        "placeOrder": "按这里完成下单",
        "confirmOrder": "加了菜后就按这里作最后确定",
        "markItem": "点击菜品可以标注已经上菜",
        "checkout": "点击按钮开始结账",
        "numberPad": "点击数字键盘输入金额",
        "pay": "点这里完成收银!"
    }
}


// WEBPACK FOOTER //
// ./src/locales/zh-CN/translation.js